module.exports = __webpack_public_path__ + "static/media/S4N4-1.310fb88d.svg";